/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useState } from 'react';
import { Popup } from '../Popup';
import { SelectOptions } from '../Options';
import { Button } from '../Button';
import { BnIcon } from '../icons_v2';
import { Icons, IOption } from '../../types';

interface IMoreMenuProps {
	options: IOption[];
	handleActions: (v: string) => void;
	disabled?: boolean;
}

/**
 * Three-dots overflow menu. When disabled, the trigger stays visible but does not open.
 */
export const MoreMenu = ({ options, handleActions, disabled = false }: IMoreMenuProps) => {
	const [isOpen, setOpen] = useState<boolean>(false);

	const handleOnActions = (v: string) => {
		setOpen(false);
		handleActions(v);
	};

	const triggerButton = (
		<Button data-aid="button-moreMenu-more" sizer="S" theme="basic" disabled={disabled}>
			<BnIcon icon={Icons.more} />
		</Button>
	);

	if (disabled) {
		return triggerButton;
	}

	return (
		<Popup
			placement="bottom-start"
			padding={0}
			trigger={isOpen}
			onOpenChange={v => setOpen(v)}
			body={<SelectOptions options={options} onSelect={handleOnActions} value={''} />}
		>
			{triggerButton}
		</Popup>
	);
};
